export { LpMyProductCodesHeaderComponent } from './header/lp-my-product-codes-header.component';
